import React from "react";

const ExternalWebsite = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        F.
        <span className="text-[#01A7D1] "> LINKS TO EXTERNAL WEBSITES</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        The Platform may contain links to other websites or resources over which
        Yostel does not have any control. Such links do not constitute an
        endorsement by Yostel of those external websites. You acknowledge that
        Yostel is providing these links to you only as a convenience, and
        further agree that Yostel is not responsible for the content of such
        external websites. We are not responsible for the protection and privacy
        of any information which you provide while visiting such external
        websites and such sites are not governed by this Policy. Your use of any
        external website is subject to the terms of use and privacy policy
        located on the linked to external website.
      </p>
    </div>
  );
};

export default ExternalWebsite;
